import styled from 'styled-components';

const SignTag = styled.div<{ color: string }>`
  margin-left: auto;
  padding: 5px 4px;
  color: ${(p) => p.color};
  border: 1px ${(p) => p.color} solid;
  border-radius: ${(p) => p.theme.radii.base};
`;

const SearchBar = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  padding-bottom: 16px;
  position: relative;
  gap: 10px;
`;

const GoTop = styled.div<{ isTablet: boolean, isMobile: boolean }>`
  position: fixed;
  bottom: ${(p) => (p.isMobile ? '22px' : p.isTablet ? '30px' : '30px')};
  right: ${(p) => (p.isMobile ? '15px' : p.isTablet ? '30px' : '30px')};
  width: 80px;
  height: 80px;
  background-color: ${(p) => p.theme.colors.secondary400};
  border-radius: 15px 15px 15px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  z-index: 1;
  padding-top: 43px;
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 23px;
  color: ${(p) => p.theme.colors.light};

  :hover {
    filter: brightness(1.1);
  }

  ::after {
    content: '';
    background-image: url('/images/index/up-arrow.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    width: 56px;
    height: 56px;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const TermsExampleWrapper = styled.div`
  background: ${(p) => p.theme.colors.gray100};
  border-left: 5px solid ${(p) => p.theme.colors.secondary500};
  padding: 15px 20px;
  margin: 20px 0;
`


export { SignTag, SearchBar, GoTop, TermsExampleWrapper };